export default __webpack_public_path__ + "5779ffcb2b0cc454df235c779b45b202.svg";